import InfoIcon from '@mui/icons-material/Info';
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	Stack,
	Typography,
	useMediaQuery,
	useTheme,
} from '@mui/material';

import PhoneNumberLink from '../PhoneNumberLink';

import useFacilityStore from '@src/store/modules/facility.store';
import useGlobalUXStore from '@src/store/modules/global-ux.store';

export default function GlobalErrorDialog() {
	const theme = useTheme();
	const isExtraSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
	const { facility } = useFacilityStore((store) => store);
	const { globalErrorDialogOpen, setGlobalErrorDialogOpen } = useGlobalUXStore((store) => store);
	return (
		<Dialog open={globalErrorDialogOpen} onClose={() => setGlobalErrorDialogOpen(false)}>
			<Stack alignItems="center" p={3}>
				<InfoIcon fontSize="large" sx={{ color: 'error.dark', py: 3 }} />
				<Typography variant={isExtraSmallScreen ? 'header4' : 'header3'} color="text.primary">
					We cannot process this request, please try again later.
				</Typography>
			</Stack>
			<DialogContent sx={{ pb: 4 }}>
				{facility?.phoneNumber && (
					<Stack alignItems="center">
						<Typography
							variant={isExtraSmallScreen ? 'bodyMediumBook' : 'bodyLargeBook'}
							color="text.secondary"
							textAlign="center"
						>
							Please call <PhoneNumberLink phoneNumber={facility.phoneNumber} variant="bodyLargeBook" />
						</Typography>
					</Stack>
				)}
			</DialogContent>
			<DialogActions
				sx={{
					bgcolor: 'backgrounds.neutral',
					justifyContent: isExtraSmallScreen ? 'flex-end' : 'center',
					display: 'flex',
				}}
			>
				<Button variant="tertiaryDefault" size="M" onClick={() => setGlobalErrorDialogOpen(false)}>
					Dismiss
				</Button>
			</DialogActions>
		</Dialog>
	);
}
